import { useState, useEffect } from "react";
import verified from "../../../assets/images/verified.svg";
import errorImg from "../../../assets/images/error_card.svg";
import PopUp from "../../ui/PopUp";
import Input from "../../form-controls/Input";
import PrimaryButton from "../../ui/PrimaryButton";
import { useInvoice } from "../../../hooks/useInvoice";
import { usePayload } from "../../../hooks/usePayload";
import { processCheckout, verifyMsisdin } from "../../../service/api";
import VerificationBox from "./VerificationBox";

const TelecelForm = () => {
  const { invoice, getWallet, id, transID, getRedirectionURL, setCurrentStep } =
    useInvoice();
  const { payload, setPayload } = usePayload();

  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isMsisdnVerified, setIsMsisdnVerified] = useState(false);
  const [otp, setOtp] = useState("");

  const [notification, setNotification] = useState({
    img: verified,
    title: "",
    text: ""
  });

  /* 🔁 Reset verification if number changes */
  useEffect(() => {
    setIsMsisdnVerified(false);
    setOtp("");
  }, [payload?.customer_msisdn]);

  const handleChange = (e) => {
    setPayload({ ...payload, [e.target.name]: e.target.value });
  };

  /* STEP 1: VERIFY NUMBER */
  const handleVerifyNumber = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const res = await verifyMsisdin({
        customer_msisdn: payload?.customer_msisdn,
        payment_processor_id: getWallet("TELECEL_MONEY")?.public_id
      });

      if (res?.response?.valid) {
        setIsMsisdnVerified(true);
        setCurrentStep(2);
      } else {
        throw new Error("Invalid number");
      }
    } catch (err) {
      setNotification({
        img: errorImg,
        title: "Verification Failed",
        text:
          err?.response?.data?.error?.customer_msisdn?.error_string ||
          "Please check your wallet number"
      });
      setIsOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  /* STEP 2: VERIFY OTP & PAY */
  const handleOTPVerify = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const res = await processCheckout({
        ...payload,
        otp,
        invoice_id: id,
        payment_processor_id: getWallet("TELECEL_MONEY")?.public_id,
        trans_id: transID
      });

      setNotification({
        img: verified,
        title: "Payment Successful",
        text: "The payment has been made successfully."
      });
      setCurrentStep(3);
      setIsOpen(true);

      if (res?.response?.redirect_url) {
        const params = getRedirectionURL({
          transaction_id: res.response.transaction_id,
          payment_processor: "Telecel Money",
          status: res.response.status === "SUCCESS" ? "true" : "false"
        });

        setTimeout(() => {
          window.location.href = `${res.response.redirect_url}?${params}`;
        }, 3000);
      }
    } catch (err) {
      setNotification({
        img: errorImg,
        title: "Payment Failed",
        text: "OTP verification failed"
      });
      setIsOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <form>
        <Input label="Email" fullWidth value={invoice?.email} disabled />

        <Input
          label="Wallet Number"
          fullWidth
          type="number"
          name="customer_msisdn"
          placeHolder="123456"
          value={payload?.customer_msisdn || ""}
          onChange={handleChange}
          prefix={
            <>
              <img className="logo" src="/flag.png" alt="country logo" />
              <span>+226</span>
            </>
          }
        />

        <VerificationBox
          walletName="Telecel Money"
          disabled={!isMsisdnVerified}
          otp={otp}
          setOtp={setOtp}
        />

        <div className="text-center">
          <PrimaryButton
            disabled={
              isLoading ||
              (!isMsisdnVerified && !payload?.customer_msisdn) ||
              (isMsisdnVerified && !otp)
            }
            onClick={isMsisdnVerified ? handleOTPVerify : handleVerifyNumber}
            text={
              <div className="verify-btn">
                {isLoading && (
                  <img
                    className="btn-loader"
                    src="https://raw.githubusercontent.com/Codelessly/FlutterLoadingGIFs/master/packages/cupertino_activity_indicator_square_medium.gif"
                    alt="Loading"
                  />
                )}
                {isLoading ? "Processing" : isMsisdnVerified ? "Pay" : "Verify"}
              </div>
            }
          />
        </div>
      </form>
      <PopUp
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        img={notification.img}
        title={notification.title}
        text={notification.text}
      />
    </>
  );
};

export default TelecelForm;
